import { render, staticRenderFns } from "./PriceDataGrid.vue?vue&type=template&id=d72b593e&scoped=true&"
import script from "./PriceDataGrid.vue?vue&type=script&lang=js&"
export * from "./PriceDataGrid.vue?vue&type=script&lang=js&"
import style0 from "./PriceDataGrid.vue?vue&type=style&index=0&id=d72b593e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72b593e",
  null
  
)

export default component.exports